import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { BrowserRouter, Route } from 'react-router-dom';
import { HomePage, NotFoundPage } from './pages';
import LoginPage from "./components/login-form/login-page";
import { Switch } from 'devextreme-react';
import MyRoutes from "./MyRoutes";
import {EmitirCndImovel} from "./pages"

ReactDOM.render(
  <BrowserRouter>
    <Route path="/:prefeitura" component={App} />
    <Route exact path="/" component={NotFoundPage} />
    
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
